// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取学生加入活动
export function getStudentActivities(data, token) {
  return request({
    url: "/api/article/student_apply",
    method: "post",
    data,
    headers: { token: token },
  });
}

// 获取教师加入活动
export function getTeacherActivities(data, token) {
  return request({
    url: "/api/article/teacher_apply",
    method: "post",
    data,
    headers: { token: token },
  });
}

// 上传活动文件
export function activityFile(data, token) {
  return request({
    url: "/api/article/activity_file",
    method: "post",
    data,
    headers: { token: token, "Content-Type": "multipart/form-data" },
  });
}
